<script lang="ts">
  import type { App } from '$lib/types';
  import {
    MetaTags,
    JsonLd,
    type MetaTagsProps,
    type JsonLdProps,
    type Twitter,
    type OpenGraph
  } from 'svelte-meta-tags';

  import { page } from '$app/stores';
  import { browser } from '$app/environment';
  import { getContext } from 'svelte';
  import { BASE_APP_URL, OPENGRAPH_IMAGE_SIZE, META_TAGS } from '$lib/constants';

  const { irkAccount } = getContext<App>('app');

  export let title: string;
  export let titleTemplate = '%s - Metafy';
  export let description = META_TAGS.description;
  export let schema: JsonLdProps['schema'] | null = null;
  export let openGraph: OpenGraph = {};
  export let twitter: Twitter = {};
  export let url = `${BASE_APP_URL}${$page.url.pathname}`;
  export let cardType: Twitter['cardType'] = 'summary_large_image';
  export let image = '';
  export let imageAlt = 'Metafy';
  export let robots: string | boolean = false;
  export let keywords: string[] = [];
  $: unreadNotificationCount = $irkAccount?.unreadNotificationCount ?? 0;
  $: titleWithCount = unreadNotificationCount > 0 ? `(${unreadNotificationCount}) ${title}` : title;

  let metaTagsProps: MetaTagsProps = {};
  $: metaTagsProps = {
    keywords,
    title: titleWithCount,
    titleTemplate,
    description,
    robots,
    ...(browser
      ? {}
      : {
          canonical: url,
          openGraph: {
            title,
            description,
            siteName: 'Metafy',
            images: [
              {
                url: image,
                alt: imageAlt,
                ...OPENGRAPH_IMAGE_SIZE
              }
            ],
            ...openGraph
          },
          twitter: {
            site: '@TryMetafy',
            title: openGraph?.title || title,
            cardType,
            description,
            image,
            imageAlt,
            ...twitter
          }
        })
  };
</script>

<MetaTags {...metaTagsProps} />

{#if !browser && schema}
  <JsonLd {schema} />
{/if}
